import { useCallback, useMemo } from 'react';

import { TextFieldProps } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { BaseNonRangeNonStaticPickerProps } from '@mui/x-date-pickers/internals/models/props/basePickerProps';

type DateInputProps = Pick<TextFieldProps, 'disabled' | 'error' | 'variant' | 'helperText' | 'id'> &
  Pick<BaseNonRangeNonStaticPickerProps, 'label'> & {
    value: string | null;
    dataTest?: string;
    onDateChange: (id: string, value: Date) => void;
  };

const DateInput = ({
  id,
  label,
  value,
  onDateChange,
  helperText,
  disabled = false,
  error = false,
  dataTest,
  variant = 'standard',
}: DateInputProps) => {
  const onDateChangeCallback = useCallback((value: Date) => onDateChange(id, value), [
    id,
    onDateChange,
  ]);

  const dateValue = useMemo(() => {
    if (value === null || value.length === 0) {
      return null;
    }
    return new Date(value);
  }, [value]);

  return (
    <DatePicker
      value={dateValue}
      label={label}
      onChange={onDateChangeCallback}
      disabled={disabled}
      data-test={dataTest}
      slotProps={{ textField: { variant, error: error, helperText: helperText, id } }}
    />
  );
};

export default DateInput;
